<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M14.581 4.074c0-.778.634-1.408 1.417-1.408.782 0 1.416.63 1.416 1.408v1.16c0 .066-.004.13-.013.195 3.605.621 6.347 3.746 6.347 7.506v4.974l3.873 3.849a.99.99 0 01-.351 1.632 1 1 0 01-.522.146H5.08a.997.997 0 01-1-1.035.988.988 0 01.293-.743l3.918-3.894a1.01 1.01 0 01.122-.104v-4.825c0-3.704 2.66-6.79 6.185-7.477a1.403 1.403 0 01-.018-.225v-1.16zM12 25.689c0-.056.001-.11.004-.166h2.004a1.662 1.662 0 001.658 1.822h.668a1.662 1.662 0 001.658-1.822h2.005c.002.055.003.11.003.166 0 2.012-1.641 3.644-3.666 3.644h-.667C13.642 29.333 12 27.7 12 25.689z"/></svg>
</template>

<script>
export default {
  name: 'objectsBellFilled'
}
</script>
